import axios from '../axios';
const listProducts = () => axios.get("/v2/cadastro/produtos");
const listOriginators = () => axios.get("/v2/cadastro/originadores");

export {
    listProducts,
    listOriginators,
};